import { Controller } from "@hotwired/stimulus"

// Generic wrapper around the native <dialog> element — used for the book
// detail modal on the storefront card grid.
export default class extends Controller {
  static targets = ["dialog", "zoom"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.closeZoom()
    this.dialogTarget.close()
  }

  zoomCover() {
    if (!this.hasZoomTarget) return

    this.zoomTarget.classList.add("open")
    this.zoomTarget.setAttribute("aria-hidden", "false")
  }

  closeZoom() {
    if (!this.hasZoomTarget) return

    this.zoomTarget.classList.remove("open")
    this.zoomTarget.setAttribute("aria-hidden", "true")
  }

  cancel(event) {
    if (!this.hasZoomTarget || !this.zoomTarget.classList.contains("open")) return

    event.preventDefault()
    this.closeZoom()
  }
}
